/**
 * Prefer human-readable Brand UM identity over raw Auth0 subs.
 * Does not invent names — uses API displayName/email when present.
 */
export function resolveBrandUserDisplayName({
  displayName,
  email,
  auth0Sub,
} = {}) {
  const name = String(displayName || "").trim();
  const mail = String(email || "").trim();
  const sub = String(auth0Sub || "").trim();
  if (name && !/^auth0\|/i.test(name)) return name;
  if (mail && !/^auth0\|/i.test(mail)) return mail;
  if (sub) return sub;
  return "—";
}
